import { Observable } from 'rxjs';
import httpService from './httpService';
import { Notification } from '../data/models/notification.model';

class NotificationService {
  private readonly apiBase;

  constructor() {
    const { __environment__ } = window as any;
    this.apiBase = __environment__.REACT_APP_NOTIFICATION_API_URL.trim();
  }

  public getNotifications(): Observable<Notification[]> {
    const url = this.apiBase;
    return httpService.getJSON(url);
  }

  public getNotification(id: string): Observable<Notification> {
    const url = `${this.apiBase}/${id}`;
    return httpService.getJSON(url);
  }

  public dismissNotification(id: number): Observable<Notification> {
    const url = `${this.apiBase}/${id}`;
    return httpService.patchJSON(url, { state: 'dismissed' });
  }
}

const notificationService = new NotificationService();

export default notificationService;
